import type { components } from '@fluencelabs/vodopad-admin-api'
import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { unwrapApiData } from '@/api/unwrapApiResult'

type ClusterDto = components['schemas']['ClusterDto']

async function fetchClusters(): Promise<ClusterDto[]> {
  const result = await client.GET('/v1/clusters')
  return unwrapApiData(result, 'Failed to fetch clusters').items
}

export function useClustersQuery() {
  return useQuery({
    queryKey: ['clusters'],
    queryFn: fetchClusters,
    staleTime: 10 * 60 * 1000,
  })
}

export function useClusters() {
  return useClustersQuery().data ?? []
}
